import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../communs/NavBar";
import FooterSection from "../../components/sections/FooterSection";
import HeroSectionDetailsProject from "./layout-details-project/HeroSectionDetailsProject";
import Loader from "../../biblio/Loader/Loader";
import headerBg from "../../assets/images/seasonal-projects.png";
import headerMobileBg from "../../assets/background/seasonal-projects-Mob.png";
import { getProjectBranches } from "../../apis/actions/projects.actions";
import { AppDispatch, RootState } from "../../apis/store";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../components/utils/utils";

const itemPerPage = 8;

const BranchProjects: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const currentRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(1);

  const projectBranches = useSelector(
    (state: RootState) => state?.projects?.projectBranches,
  );

  useEffect(() => {
    dispatch(getProjectBranches());
  }, [dispatch]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [projectBranches]);

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };

  const paginatedBranches = projectBranches?.slice(
    itemPerPage * (active - 1),
    itemPerPage * active,
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="takaful--projects-container">
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="المشاريع"
        subTitle="مشاريع الفروع"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type="المشاريع"
      />
      <div className="takaful--branch-cards-section" ref={currentRef}>
        {!paginatedBranches?.length ? (
          <p className="takaful--branch-empty">لا توجد فروع متاحة حالياً</p>
        ) : (
          <div className="takaful--branch-cards-grid">
            {paginatedBranches.map((branch: any) => (
              <div
                key={branch.id}
                className="takaful--branch-card"
                onClick={() => navigate(`/branch-projects/${branch.id}`)}
              >
              {branch.icon && (
                  <img
                  src={branch.icon}
                    alt={branch.name}
                    className="takaful--branch-card-icon"
                  />
                )}
                <span>{branch.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {projectBranches?.length > itemPerPage && (
        <PaginationComponent
          active={active}
          scroll={() => scroll(currentRef)}
          total={projectBranches.length}
          itemPerPage={itemPerPage}
          setActive={(nb) => updateActive(nb)}
        />
      )}
      <FooterSection />
    </div>
  );
};

export default BranchProjects;
